import HTTP from "../http";
import Jsona from "jsona";

const dataFormatter = new Jsona();

export default {
  async getTermsOfUse() {
    try {
      const response = await HTTP.normal.get("/terms-of-use");

      return dataFormatter.deserialize(response.data)[0];
    } catch (e) {
      throw "Ocorreu um erro inesperado, tente atualizar a página!";
    }
  },

  async response(payload) {
    try {
      await HTTP.normal.post("/accounts-terms-of-use", payload);
    } catch (e) {
      throw "Ocorreu um erro ao salvar a sua resposta!";
    }
  }
};



// WEBPACK FOOTER //
// ./src/api/modules/accountTermsOfUse.js